<template>
    <v-dialog v-model="dialog" persistent :max-width="width" :retain-focus="false"
              :fullscreen="$vuetify.breakpoint.smAndDown"> <!---->
        <v-card flat class="grey lighten-5">
            <v-card-title class="primary--text white">
                <v-icon v-if="headerIcon" class="mr-3 d-inline-block" color="primary">{{headerIcon}}</v-icon>
                <slot name="headerIcon" class="d-inline-block"></slot>
                <span class="heebo fw600 text-truncate d-inline-block">
                    {{headerText}}</span>
                <v-spacer></v-spacer>
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <slot name="subTitle"></slot>
            <div>
                <v-card-text class="pa-0">
                    <slot></slot>
                </v-card-text>
            </div>
        </v-card>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" fab dark bottom right @click="close()"
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
    </v-dialog>
</template>

<script>
    export default {
        name: "info-container",
        data: () => ({
            dialog: false,
        }),
        props: {
            headerText: {default: ''},
            headerIcon: {default: ''},
            useRoute: {default: true},
            action: {default: ''},
            validActions: {default: []},
            width: {default: 450},
        },
        methods: {
            close(){
                if ( this.useRoute ) {
                    window.history.back();
                    this.$emit('close');
                } else {
                    this.$emit('close');
                }
            }
        },
        watch: {
            '$route.query.action'(){
                this.dialog = this.validActions.indexOf(this.$route.query.action) !== -1;
            }
        }
    }
</script>

<style scoped>
</style>